import { Link } from "react-router-dom";
import { CATEGORIES } from "../lib/categories";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 mt-24">
      <div className="max-w-[1440px] mx-auto px-5 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center gap-3 mb-5">
            <span className="w-9 h-9 bg-kinetic text-obsidian font-display font-extrabold text-sm flex items-center justify-center">M/M</span>
            <span className="font-display font-extrabold tracking-[0.18em] text-sm uppercase">Modern Man</span>
          </div>
          <p className="text-ash text-sm leading-relaxed max-w-xs">
            The chronicle of contemporary men's culture — style, sound, machines, ink and ideas, written for men who move first.
          </p>
        </div>
        <div>
          <p className="text-xs font-mono uppercase tracking-[0.25em] text-kinetic mb-5">Sections</p>
          <div className="grid grid-cols-2 gap-x-6 gap-y-3">
            {CATEGORIES.map((c) => (
              <Link key={c.slug} to={`/category/${c.slug}`} className="text-sm text-ash hover:text-porcelain transition-colors">
                {c.label}
              </Link>
            ))}
          </div>
        </div>
        <div>
          <p className="text-xs font-mono uppercase tracking-[0.25em] text-kinetic mb-5">Community</p>
          <div className="flex flex-col gap-3">
            <Link to="/voices" className="text-sm text-ash hover:text-porcelain transition-colors">Voices — have your say</Link>
            <Link to="/voices" className="text-sm text-ash hover:text-porcelain transition-colors">Debates & discussions</Link>
            <Link to="/lounge" className="text-sm text-ash hover:text-porcelain transition-colors">The Lounge — live chat</Link>
            <Link to="/deals" className="text-sm text-ash hover:text-porcelain transition-colors">The deal vault</Link>
            <Link to="/directory" className="text-sm text-ash hover:text-porcelain transition-colors">UK business directory</Link>
          </div>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-[1440px] mx-auto px-5 lg:px-10 py-6 flex flex-col sm:flex-row justify-between gap-3">
          <p className="text-[11px] font-mono uppercase tracking-[0.2em] text-ash">© 2026 Modern Man Magazine</p>
          <p className="text-[11px] font-mono uppercase tracking-[0.2em] text-ash">Issue Nº 01 — Forever in progress</p>
        </div>
        <div className="max-w-[1440px] mx-auto px-5 lg:px-10 pb-6">
          <p data-testid="affiliate-disclosure" className="text-[11px] text-ash/60 leading-relaxed max-w-2xl">
            As an Amazon Associate, this magazine earns from qualifying purchases made through our AI-recommended links.
          </p>
        </div>
      </div>
    </footer>
  );
}
